module.exports = __webpack_public_path__ + "img/block13.c7b12179.png";